<pp-button-dropdown
  [ppSrc]="allCollapsed ? EIconPath.ICON_TABLE_EXPAND_ALL : EIconPath.ICON_TABLE_COLLAPSE_ALL"
  [ppText]="(allCollapsed ? 'expand_all' : 'collapse_all') | ppTranslate"
  [ppTitle]="(allCollapsed ? 'expand_all' : 'collapse_all') | ppTranslate"
  [ppAriaLabel]="allCollapsed ? 'expand all groups' : 'collapse all groups'"
  (ppAction)="toggleGroups()"
  ppTooltip
  id="bulkGrouptBtn"
  data-m-target="Bulk toggle groups button"
  [ppDisabled]="!ppDataFetched()"
  class="siteOptions__dropdownButton"
/>
